export function cleanupLocalStorageWeekly(
  pattern: RegExp,
  storageKey = "__lastCleanup",
  intervalDays = 7
): void {
  const now = Date.now();
  const lastCleanupStr = localStorage.getItem(storageKey);
  const lastCleanup = lastCleanupStr ? parseInt(lastCleanupStr, 10) : 0;

  const intervalMs = intervalDays * 24 * 60 * 60 * 1000;

  if (now - lastCleanup < intervalMs) return;

  // Loop through localStorage keys and remove if matched
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && pattern.test(key)) {
      localStorage.removeItem(key);
    }
  }

  // Update last cleanup timestamp
  localStorage.setItem(storageKey, now.toString());
}
